import validateTextInput from '../validation_utils/validateTextInput'
import validateSelect from '../validation_utils/validateSelect'

export default function authenticationRegistrationFormValidation () {
  const registrationForm = Array.from(document.getElementsByClassName('vjs-registration-form'))[0]

  if (registrationForm) {
    const tradeFormCheckbox = document.getElementById('vjs-trade-form')
    if (tradeFormCheckbox) {
      tradeFormCheckbox.addEventListener('change', toggleTradeFields)
      toggleTradeFields()
    }

    ['change', 'submit'].forEach(formEvent => {
      registrationForm.addEventListener(formEvent, event => {
        if (event.target.id !== 'vjs-trade-form') {
          validateRegistrationForm(event)
        }
      })
    })
  }
}

function toggleTradeFields () {
  const tradeFormCheckbox = document.getElementById('vjs-trade-form')
  const tradeFields = [
    'vjs-user-account-attributes-phone-number',
    'vjs-user-trade-buyer-account-attributes-company-name',
    'vjs-user-trade-buyer-account-attributes-website',
    'vjs-user-trade-buyer-account-attributes-business-type',
    'vjs-user-trade-buyer-account-attributes-company-country',
    'vjs-user-trade-buyer-account-attributes-company-spend',
    'vjs-user-trade-buyer-account-attributes-current-project',
    'vjs-user-account-attributes-vat-number',
    'vjs-user-account-attributes-vat-registered'
  ]

  const nonTradeFields = [
    'vjs-user-account-attributes-postcode',
    'vjs-user-account-attributes-country',
    'vjs-user-registration-driver',
    'vjs-user-registration-vintage-affinity'
  ]

  const isTradeSelected = tradeFormCheckbox.checked
  tradeFields.forEach(fieldId => {
    const fieldElement = document.getElementById(fieldId)
    if (fieldElement) {
      const fieldContainer = fieldElement.closest('.vsd-form-field, .vsd-custom-select__container')
      if (fieldContainer) {
        if (isTradeSelected) {
          fieldContainer.style.display = 'block'
          // Make required fields actually required when visible
          const isOptionalForTrade =
            fieldId === 'vjs-user-trade-buyer-account-attributes-website' ||
            fieldId === 'vjs-user-account-attributes-vat-registered'
          if (!isOptionalForTrade) {
            fieldElement.required = true
          }
        } else {
          fieldContainer.style.display = 'none'
          // Remove required attribute when hidden
          fieldElement.required = false
          // Clear any existing errors
          const errorElement = fieldContainer.querySelector('.vsd-form-field__error')
          if (errorElement) {
            errorElement.textContent = ''
          }
        }
      }
    }
  })

  nonTradeFields.forEach(fieldId => {
    const fieldElement = document.getElementById(fieldId)
    if (fieldElement) {
      const fieldContainer = fieldElement.closest('.vsd-form-field, .vsd-custom-select__container')
      if (fieldContainer) {
        if (isTradeSelected) {
          fieldContainer.style.display = 'none'
          // Make required fields actually required when visible
          fieldElement.required = false
        } else {
          fieldContainer.style.display = 'block'
          // Remove required attribute when hidden
          fieldElement.required = true
          // Clear any existing errors
          const errorElement = fieldContainer.querySelector('.vsd-form-field__error')
          if (errorElement) {
            errorElement.textContent = ''
          }
        }
      }
    }
  })

  syncVatNumberRequirement()
  updateMarketingOptInText(isTradeSelected)
}

function validateRegistrationForm (event) {
  const tradeFormCheckbox = document.getElementById('vjs-trade-form')
  const tradeFormSelected = tradeFormCheckbox && tradeFormCheckbox.checked
  if (tradeFormSelected) {
    syncVatNumberRequirement()
  }
  // Always validate these core fields
  validateTextInput(event, 'vjs-user-account-attributes-first-name', setMissingRequiredFieldErrorText)
  validateTextInput(event, 'vjs-user-account-attributes-last-name', setMissingRequiredFieldErrorText)
  validateTextInput(event, 'vjs-user-password', setPasswordValidationErrorText)
  validateSelect(event, 'vjs-user-acquisition-channel', setMissingRequiredFieldErrorText)

  if (tradeFormSelected) {
    validateTextInput(event, 'vjs-user-account-attributes-phone-number', setMissingRequiredFieldErrorText)
    validateTextInput(event, 'vjs-user-trade-buyer-account-attributes-company-name', setMissingRequiredFieldErrorText)
    validateSelect(event, 'vjs-user-trade-buyer-account-attributes-business-type', setMissingRequiredFieldErrorText)
    validateSelect(event, 'vjs-user-trade-buyer-account-attributes-company-country', setMissingRequiredFieldErrorText)
    validateSelect(event, 'vjs-user-trade-buyer-account-attributes-company-spend', setMissingRequiredFieldErrorText)
    validateTextInput(event, 'vjs-user-trade-buyer-account-attributes-current-project', setMissingRequiredFieldErrorText)
    validateVatInput(event)
  } else {
    validateSelect(event, 'vjs-user-registration-driver', setMissingRequiredFieldErrorText)
    validateSelect(event, 'vjs-user-registration-vintage-affinity', setMissingRequiredFieldErrorText)
    validateSelect(event, 'vjs-user-account-attributes-country', setMissingRequiredFieldErrorText)
  }
}

function setMissingRequiredFieldErrorText (validityObject, errorEl) {
  const { valueMissing } = validityObject

  if (valueMissing) errorEl.textContent = 'This field is required'
}

function setPasswordValidationErrorText (validityObject, errorEl) {
  const { valueMissing, tooShort } = validityObject

  if (valueMissing) {
    errorEl.textContent = 'You need to enter a password'
  } else if (tooShort) {
    errorEl.textContent = 'This password is too short'
  }
}

function syncVatNumberRequirement () {
  const tradeFormCheckbox = document.getElementById('vjs-trade-form')
  const vatRegisteredCheckbox = document.getElementById('vjs-user-account-attributes-vat-registered')
  const vatNumberInput = document.getElementById('vjs-user-account-attributes-vat-number')
  if (!vatNumberInput || !tradeFormCheckbox?.checked || !vatRegisteredCheckbox) return

  vatNumberInput.required = vatRegisteredCheckbox.checked
  if (!vatNumberInput.required) {
    clearVatNumberFieldValidation()
  }
}

function clearVatNumberFieldValidation () {
  const fieldId = 'vjs-user-account-attributes-vat-number'
  const field = document.getElementById(fieldId)
  const label = document.querySelector(`label[for="${fieldId}"]`)
  const errorEl = document.querySelector(`#${fieldId} ~ .vsd-form-field__error`)
  if (!field || !errorEl) return

  field.classList.remove('vsd-form-field--invalid')
  errorEl.textContent = ''
  errorEl.classList.remove('vsd-form-field__error--visible')
  if (label) label.className = ''
}

function validateVatInput (event) {
  const vatRegisteredCheckbox = document.getElementById('vjs-user-account-attributes-vat-registered')
  if (!vatRegisteredCheckbox?.checked) {
    clearVatNumberFieldValidation()
    return
  }
  validateTextInput(event, 'vjs-user-account-attributes-vat-number', setMissingRequiredFieldErrorText)
}

function updateMarketingOptInText (isTradeSelected) {
  const consumerLabel = document.getElementById('vjs-user-marketing-opt-in-consumer-label')
  const tradeLabel = document.getElementById('vjs-user-marketing-opt-in-trade-label')
  if (isTradeSelected) {
    consumerLabel.style.display = 'none'
    tradeLabel.style.display = 'block'
  } else {
    consumerLabel.style.display = 'block'
    tradeLabel.style.display = 'none'
  }
}
